import React from 'react'
import cx from 'classnames'

import styles from './EntryForm.module.css'
import ChatBotLogo from 'Assets/images/hfchatbot-logo.svg'

import FormError from 'Design/components/FormError'

const EntryForm = ({ className, children, ...rest }) => {
  return (
    <div className={cx(styles.Container, className)} {...rest}>
      <div>
        <ChatBotLogo height='25' title='Chatbot' />
      </div>
      {children}
    </div>
  )
}

export const EntryFormContainer = ({ className, ...rest }) => {
  return <div className={cx(styles.FormContainer, className)} {...rest} />
}

export const EntryFormError = ({ className, ...rest }) => {
  return <FormError className={cx(styles.FormError, className)} {...rest} />
}

export default EntryForm
